import React from 'react'
import './career.css';
import background from './images/careers.jpg'
import Card from 'react-bootstrap/Card';


const career = () => {
    return (
        <>
            <div className='container'>
                <div className='care'>
                    <div style={{ backgroundImage: `url(${background})` }}>
                        {/* <img className="d-block w-100" src={img111} alt="First slide" ></img> */}
                        <div className="text-center bg-danger p-3">
                            <h2>Charged Ahead</h2>
                            <h4>Innovation in the ERA of Digital World</h4>
                            <h5>Power the Future of Virtual World</h5>
                        </div>
                        <div className='container '>
                            <div className='row'>
                                <div className='col m-3 '>
                                    <Card style={{ width: '25rem' }}>
                                        <Card.Body>
                                            <Card.Title>Role Information</Card.Title>
                                            <ul>
                                                <li><h5>Position</h5>
                                                    <h6>Developer</h6>
                                                </li>
                                                <li>
                                                    <h5>Department</h5>
                                                    <h6>Technology</h6>
                                                </li>
                                                <li>
                                                    <h5>Location</h5>
                                                    <h6>Delhi</h6>
                                                </li>
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>

                                <div className='col m-3'>
                                    <Card style={{ width: '25rem' }}>
                                        <Card.Body>
                                            <Card.Title>Requirement</Card.Title>
                                            <ul>
                                                <li>Advanced Design</li>
                                                <li>Smart Working skill</li>
                                                <li>Graduate</li>
                                                <li>Fresher</li>
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col m-3'>
                                    <Card style={{ width: '25rem' }}>
                                        <Card.Body>
                                            <Card.Title>Company Value</Card.Title>
                                            <ul>
                                                <li>Innovation</li>
                                                <li>Sustainability</li>
                                                <li>Excellence</li>
                                                <li>Performance</li>
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className='col m-3'>
                                    <Card style={{ width: '25rem' }}>
                                        <Card.Body>
                                            <Card.Title>Next Steps</Card.Title>
                                            <ul>
                                                <li>Complete Onboarding documentation</li>
                                                <li>Meet your development team</li>
                                                <li>Set up your development environment</li>
                                                <li>Review current projects</li>
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default career



